// 팝업의 취소버튼
export const DisabledBorderButtonBox = ({ title }) => {
    return (
        <button disabled type='button' className='btn gray-bg'>
            {title}
        </button>
    );
};

export const BlueBorderButtonBox = ({ title, onClick }) => {
    return (
        <button type='button' className='btn blue-border' onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};

export const BlueBgButtonBox = ({ title, onClick }) => {
    return (
        <button type='button' className='btn blue-bg' onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};

export const RedBorderButtonBox = ({ title, onClick }) => {
    return (
        <button type='button' className='btn red-border' onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};

export const RedBgButtonBox = ({ title, onClick }) => {
    return (
        <button type='button' className='btn red-bg' onClick={(e) => onClick(e)}>
            {title}
        </button>
    );
};
